// script.js (torus index.html) ~sdg
'use strict'
console.time('LoadTime')
import * as THREE from 'three'

// Styles
import './normalize.css'
import './style.css'

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()
const group = new THREE.Group()
scene.add(group)

// Axes Helper
//const axesHelper = new THREE.AxesHelper(2)
//scene.add(axesHelper)

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight
}
// Resize
window.addEventListener('resize', () =>
{
  // Update sizes
  sizes.width = window.innerWidth
  sizes.height = window.innerHeight
  // Update camera
  camera.aspect = sizes.width / sizes.height
  camera.updateProjectionMatrix()
  // Update renderer
  renderer.setSize(sizes.width, sizes.height)
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Controls
 */
//import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
//const controls = new OrbitControls(camera, canvas)
//controls.enableDamping = true

/**
 * Debug lil-gui
 */
import * as dat from 'lil-gui'
const gui = new dat.GUI({ width: 200 })
gui.close()
gui.hide()

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(50, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 4
scene.add(camera)

// Renderer
const renderer = new THREE.WebGLRenderer({
  canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Objects
 */
const textureLoader = new THREE.TextureLoader()

// Normal
const normalMaterial = new THREE.MeshNormalMaterial({
  flatShading: true
})
const normal = new THREE.Mesh(new THREE.TorusGeometry(0.3, 0.15, 8, 32), normalMaterial)
normal.position.set(-0.5, 1, -1)

// Basic
const basicTexture = textureLoader.load('./textures/pictures/flower.jpg')
const basicMaterial = new THREE.MeshBasicMaterial({
  map: basicTexture
})
const basic = new THREE.Mesh(new THREE.TorusGeometry(0.3, 0.2, 4, 5), basicMaterial)

// MatCap
const matCapTexture = textureLoader.load('./textures/matcaps/3.png')
const matCapMaterial = new THREE.MeshMatcapMaterial({
  matcap: matCapTexture,
  color: new THREE.Color(0x00ff00)
})
const matCap = new THREE.Mesh(new THREE.TorusGeometry(0.2, 0.18, 4, 32), matCapMaterial)
matCap.position.set(0.3, -0.5, 0.5)

group.add(basic, normal, matCap)

/**
 * Animate
 */
const clock = new THREE.Clock()
const animate = () =>
{
  const elapsedTime = clock.getElapsedTime()
  // Update controls
  //controls.update()

  // Update objects
  normal.rotation.x = 0.2 * elapsedTime
  normal.rotation.y = 0.2 * elapsedTime

  basic.rotation.x = - 0.1 * elapsedTime
  basic.rotation.y = - 0.1 * elapsedTime

  matCap.rotation.x = 0.3 * elapsedTime
  matCap.rotation.y = 0.3 * elapsedTime

  // Render
  renderer.render(scene, camera)
  window.requestAnimationFrame(animate)
}
animate()
console.timeEnd('LoadTime')
// EOF script.js (torus index.html) ~sdg